import { Task } from 'components/Icons';
import SplashMessage from 'components/SplashMessage';
import { isEqual } from 'lodash-es';
import React from 'react';
import { useSelector } from 'react-redux';
import { initialState } from 'routes/forecast/redux/modules/forecast.reducer';
import { getForecastQuery } from 'routes/forecast/redux/modules/forecast.selectors';

interface Props {
  isLoading: boolean;
}

const ForecastEmptyPlaceholder: React.FC<Props> = ({ isLoading }) => {
  const initialQuery = initialState.query;
  const query = useSelector(getForecastQuery);
  const hasActiveQuery = !isEqual(initialQuery, query);

  const heading = () => {
    if (isLoading) {
      return 'Loading...';
    }
    return 'No tasks found';
  };

  const body = () => {
    if (isLoading) {
      return null;
    }
    if (hasActiveQuery) {
      return 'Expand your search by adjusting the filters.';
    }
    return 'You haven\'t created a task yet. Click the "New task" button to start.';
  };

  return (
    <SplashMessage style={{ paddingTop: 40 }}>
      <Task />
      <h2>{heading()}</h2>
      <p>{body()}</p>
    </SplashMessage>
  );
};

export default ForecastEmptyPlaceholder;
